import classNames from 'classnames';
import React from 'react';

import BaseGroupComponent, { BaseGroupProps } from './BaseGroup';
import ErrorsComponent from 'shared/Errors/components/Errors';
import Select, { SelectProps } from 'components/elements/Select';

interface SelectGroupProps extends BaseGroupProps, SelectProps {
  errors?: string[];
}

const SelectGroup = React.forwardRef<HTMLSelectElement, SelectGroupProps>(
  (
    {
      className,
      label,
      condensed,
      inline,
      required,
      noMargin,
      errors,
      changeIndicated,
      ...props
    },
    ref
  ) => {
    const selectClasses = classNames({
      'input--condensed': condensed,
      // PLA-1055: sin esto un dropdown que cambió se veía igual que uno que no,
      // porque todos los inputs ya traen `border: 1px solid $blue` de form-base.
      'input--change-indicated': changeIndicated,
    });

    return (
      <BaseGroupComponent
        label={label}
        noMargin={noMargin}
        condensed={condensed}
        inline={inline}
        required={required}
        className={className}
        changeIndicated={changeIndicated}
      >
        <Select ref={ref} className={selectClasses} required={required} {...props} />

        {errors && <ErrorsComponent errors={errors} />}
      </BaseGroupComponent>
    );
  }
);

SelectGroup.displayName = 'SelectGroup';

export default SelectGroup;
